import selectedTagsCompute from '../computed/selectedTagsCompute'

export default [
  ({ state, resolve, props }) => {
    const selectedOptions = resolve.value(selectedTagsCompute(props.namespace))
    selectedOptions.forEach((option, index) => {
      state.set(
        `selectr.${props.namespace}.options.${option.index}.selectedIndex`,
        index
      )
    })
  }
]
